import { getSelfonboardingRequests } from "../api/selfonboardingHttpClient";
export const usePendingRequestsGrid = () => {
  return { fetchGridData: getSelfonboardingRequests };
};
